var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5434 10.5454C13.521 8.14261 15.5776 6.97366 15.6717 6.91924C14.5069 5.27691 12.7016 5.05251 12.0672 5.03462C10.5509 4.8803 9.08009 5.91207 8.30769 5.91207C7.51987 5.91207 6.33044 5.04953 5.0485 5.07487C3.39886 5.09948 1.85561 6.02315 1.0092 7.45749C-0.73756 10.3821 0.56519 14.6799 2.23872 17.0439C3.07587 18.2016 4.05409 19.4943 5.33449 19.4489C6.58713 19.3989 7.05504 18.6765 8.5667 18.6765C10.0645 18.6765 10.5039 19.4489 11.8097 19.4198C13.1541 19.3989 14.0005 18.2568 14.8083 17.0886C15.7758 15.7616 16.1643 14.4548 16.1797 14.3877C16.1481 14.3772 13.5688 13.4252 13.5434 10.5454Z",
    fill: "#3787C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0766 3.4795C11.7503 2.66467 12.2113 1.55611 12.0833 0.431152C11.1082 0.4729 9.88872 1.08347 9.18646 1.88041C8.56515 2.58267 8.01014 3.73372 8.15351 4.81619C9.2489 4.89521 10.3736 4.28166 11.0766 3.4795Z",
    fill: "#3787C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.527413cac5e155c3440a553d7913fbb0.svg";
export { ForwardRef as ReactComponent };